import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { CORE_AUTH_SECURE_ROUTE_DIALOG } from '@rd/core/tokens/popup.token';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreState } from '../../store/reducers';
import { getAuthIsLoggedIn } from '../store/selectors/auth.selectors';

@Injectable()
export class AuthGuard {
  private coreAuthSecureRouteDialogComponentType = inject(
    CORE_AUTH_SECURE_ROUTE_DIALOG,
  );

  constructor(
    private store: Store<{ core: CoreState }>,
    private dialogService: DialogService,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(getAuthIsLoggedIn).pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn && this.isPageRefresh()) {
          this.router.navigate([route.data?.redirectUrl ?? '']);
          this.dialogService.open(this.coreAuthSecureRouteDialogComponentType, {
            id: 'auth-secure-route-dialog',
            screenMode: 'center-md',
            ariaLabel: this.translateService.instant(
              'accessibility.core.auth_dialog_aria_label',
            ),
            keepModalOnRouteChange: true,
          });
          return false;
        }
        if (!isLoggedIn && !this.isPageRefresh()) {
          this.dialogService.open(this.coreAuthSecureRouteDialogComponentType, {
            id: 'auth-secure-route-dialog',
            screenMode: 'center-md',
            ariaLabel: this.translateService.instant(
              'accessibility.core.auth_dialog_aria_label',
            ),
            keepModalOnRouteChange: true,
          });
          return false;
        } else if (isLoggedIn) {
          return true;
        }
        return false;
      }),
    );
  }

  private isPageRefresh(): boolean {
    return !this.router.navigated;
  }
}
